import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { quoteRecordQuery } from "@/app/Quotes/GraphQL/quoteRecordQuery";
import { useParams } from "@tanstack/react-router";

export function useQuoteRecord() {
  const { quoteId } = useParams({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/quotes/_quoteRecordLayout/$quoteId",
  });

  const { data } = useSuspenseGqlQuery(quoteRecordQuery, {
    id: quoteId,
  });

  return data.quote;
}
